import { render, staticRenderFns } from "./radio.mpx?vue&type=template&id=e407edb2&isComponent&outputPath=components%2Fradio83ca495c%2Findex"
import script from "./radio.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio83ca495c%2Findex"
export * from "./radio.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fradio83ca495c%2Findex"
import style0 from "./radio.mpx?vue&type=style&index=0&id=e407edb2&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_83ca495c%22%7D&isComponent&outputPath=components%2Fradio83ca495c%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports